import React, { Component } from "react";
import { Link } from "react-router-dom";
import Table from "../common/table/table";

class SeasonsTable extends Component {
  columns = [
    {
      key: "edit",
      className: "col-1",
      content: season => (
        <Link to={`/seasons/${season.id}`} className="btn btn-info btn-sm">
          <i className="fa fa-edit" />
        </Link>
      )
    },
    {
      key: "delete",
      className: "col-1",
      content: season => (
        <button
          onClick={() => this.props.onDelete(season)}
          className="btn btn-danger btn-sm"
        >
          <i className="fa fa-trash" />
        </button>
      )
    },
    { key: "name", label: "Name", className: "col-10" }
  ];

  render() {
    const { seasons, onSort, sortColumn } = this.props;

    return (
      <div>
        <Table
          className="container"
          columns={this.columns}
          sortColumn={sortColumn}
          onSort={onSort}
          data={seasons}
        />
      </div>
    );
  }
}

export default SeasonsTable;



// WEBPACK FOOTER //
// ./src/components/seasons/seasonsTable.jsx